import { Stack } from "@mui/material";
import { Category } from "../../../../domain/model/Category";
import { CustomTextView } from "../../../component/CustomTextView";
import { CustomImageView } from "../../../component/CustomImageView";
import useWindowDimensions from "../../../../core/utils/UseWindowDimensions";
import { CustomButtonView } from "../../../component/CustomButtonView";
import { useTranslation } from "react-i18next";

export function ChooseCategoryDetailsView({
  category,
  onCategoryClicked,
  onPopoverClose,
}: {
  category: Category;
  onCategoryClicked: (category: Category, closePopover: () => void) => void;
  onPopoverClose: () => void;
}) {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  return (
    <Stack
      maxWidth={"100%"}
      p={1}
      spacing={2}
      minWidth={width < 700 ? "90vw" : "30vw"}
    >
      <Stack
        direction={"row"}
        alignItems={"center"}
        width={"100%"}
        justifyContent={"space-between"}
      >
        <CustomTextView
          text={category.title}
          variant="h4"
          fontWeight="bold"
          props={{ width: "100%" }}
        />
        <CustomImageView
          src={category.imageUrl}
          width={150}
          height={150}
          props={{ borderRadius: 4, border: "solid 1px black" }}
        />
      </Stack>
      (
      <>
        <CustomButtonView
          text={category.isSelected ? t("unselect") : t("select")}
          fontSize="h6"
          onClick={() => onCategoryClicked(category, onPopoverClose)}
          textColor={category.isSelected ? "red" : undefined}
        />
      </>
      )
    </Stack>
  );
}
